import React, { useEffect, useState } from 'react'
import * as CONST from "../../../includes/Constant";
import axios from 'axios';
import { Table } from 'react-bootstrap';
import { S_FORMAT_INR_CURRENCY_AND_AMOUNT, S_FORMATE_INDIAN_NUMBERS } from '../../../includes/staticData';
import { Link } from 'react-router-dom';
import BlockLoading from '../../../blocks/BlockLoading';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
import { toast } from 'react-toastify';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function ChartLatestVendorPayments({ searchParams }) {
  console.log(searchParams);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchVendorPaymentHistory();
  }, [searchParams]);

  const fetchVendorPaymentHistory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(CONST.DASH_LATEST_VENDOR_PAYMENT_HISTORY, {
        params: {
          sort_by: "id",
          sort_order: "desc",
          year: searchParams.year || "",
          department_id: searchParams.department_id || "",
          limit: 5,
          month: searchParams.month || "",
        }
      });
      if (response.data) {
        setData(response.data.data || []);
      } else {
        setData([]);
      }
    } catch (error) {
      toast.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  }
  const chartData = {
    labels: data && data.map(item => item.vendor_name),
    datasets: [
      {
        label: 'Total Paid',
        data: data && data.map(item => parseFloat(item.amount) || 0),
        backgroundColor: '#dc3545', // Tailwind green-400
        borderRadius: 4,
        barThickness: 30
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => S_FORMAT_INR_CURRENCY_AND_AMOUNT(context.raw)
        }
      }
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => S_FORMATE_INDIAN_NUMBERS(value)
        },
        grid: { drawOnChartArea: false }
      },
      x: {
        grid: { drawOnChartArea: false },
        /* ticks: {
          maxRotation: 45,
          minRotation: 45,
          autoSkip: false
        } ,*/
        ticks: {
          callback: function (value) {
            const label = this.getLabelForValue(value); // Get actual label
            const maxLength = 10; // Or use a word/char count
            return label.length > maxLength ? label.slice(0, maxLength) + '…' : label;
          },
          autoSkip: false, 
           maxRotation: 45,
          minRotation: 45,
        },
      }
    }
  };
  return (
    <>
      {loading ? (
        <div className="row"><BlockLoading /></div>
      ) : (
        <div className="card flex-fill">
          <div className="card-header">
            <div className="card-actions float-end">
              <div className="dropdown position-relative">
                <Link href="#" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false" className="">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-more-horizontal align-middle"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
                </Link>

                <div className="dropdown-menu dropdown-menu-end">
                  <Link className="dropdown-item" to={CONST.ADMIN_PRE + "vendor/payments"}>View All</Link>

                </div>
              </div>
            </div>
            <h5 className="card-title mb-0">Latest Vendor Payments</h5>
          </div>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="card-body">
              {data && data.length > 0 ? (
                <Bar data={chartData} options={chartOptions} height={150} />
              ) : (
                <h5 className="text-muted text-center">No records found.</h5>
              )}
            </div>

          )}
        </div>
      )
      }
    </>
  )
}
